module.exports = __webpack_public_path__ + "static/img/ru.0cacf46e.svg";